
    module.exports = {
      render: function(){with(this){return _c('div',{staticClass:"tooltip-icon"},[_c('img',{attrs:{"src":'/assets/tooltip-icon.svg'}}),_c('div',{staticClass:"tooltip-text"},[_c('div',{staticClass:"text-box"},[_v(_s(message))]),_m(0)])])}},
      staticRenderFns: [function(){with(this){return _c('div',{staticClass:"text-box-arrows"},[_c('div',{staticClass:"text-box-arrow-down"}),_c('div',{staticClass:"text-box-arrow"})])}}]
    };
  